<script setup>
import { ElMessage,ElMessageBox  } from 'element-plus'
import { cloneDeep } from 'lodash';
import { useTaxStore } from '@/store/modules/tax.js'
const taxStore = useTaxStore()
const { answer } = storeToRefs(taxStore);
const ruleFormRef = ref(null);
const dialogVisible = defineModel("show", {
  default: false,
  required: true,
});
const form = ref({
  idNumber: "",
  bookId: null,
  name: "",
  nationality: "中国",
  certificateType: "居民身份证",
  idNumber: "",
  sex: "男",
  occuptation: null,
  degree: null,
  taxpayerRegistrationNumber: null,
  situations: [],
  disabilityCertificateNumber: null,
  martyrsNumbers: null,
  remark: null,
  habitualResidence: null,
  permanentAddress: null,
  phone: "",
  email: null,
  openingBank: null,
  bankAccount: null,
  serviceDate: null,
  leaveDate: null,
  isEmployees: "是",
  employeeType: null,
  isSpecificIndustry: "否",
  isInvestors: "否",
  isAngelInvestors: "否",
  totalEquity: null,
  totalIndividual: null,
  employeesNo:'',
  status: '正常',
  reportStatus: '验证中',
  authenticationStatus: null,
  errorList: null,
  childEduPayCount: null,
  eduPayCount: null,
  rentingHousePayCount: null,
  buyHousePayCount: null,
  providerPayCount: null,
  infantCount: null,
});
function open(){
  form.value = {
    idNumber: "",
    bookId: null,
    name: "",
    nationality: "中国",
    certificateType: "居民身份证",
    idNumber: "",
    sex: "男",
    occuptation: null,
    degree: null,
    taxpayerRegistrationNumber: null,
    situations: [],
    disabilityCertificateNumber: null,
    martyrsNumbers: null,
    remark: null,
    habitualResidence: null,
    permanentAddress: null,
    phone: "",
    email: null,
    openingBank: null,
    bankAccount: null,
    serviceDate: null,
    leaveDate: null,
    isEmployees: "是",
    employeeType: null,
    isSpecificIndustry: "否",
    isInvestors: "否",
    isAngelInvestors: "否",
    totalEquity: null,
    totalIndividual: null,
    employeesNo:'',
    status: '正常',
    reportStatus: '验证中',
    authenticationStatus: null,
    errorList: null,
    childEduPayCount: null,
    eduPayCount: null,
    rentingHousePayCount: null,
    buyHousePayCount: null,
    providerPayCount: null,
    infantCount: null,
  }
}
function getBirthDateFromIdCard(idCard) {
    // 检查身份证号是否为18位
    if (idCard.length !== 18) {
        return ElMessage({
          type:'info',
          message:"身份证格式有误",
          offset:400
        })
    }

    // 提取出生年月日部分
    let birthDateStr = idCard.substring(6, 14);

    // 格式化为 YYYY-MM-DD 的形式
    let year = birthDateStr.substring(0, 4);
    let month = birthDateStr.substring(4, 6);
    let day = birthDateStr.substring(6, 8);
    form.value.year = `${year}-${month}-${day}`;
    // 返回出生年月日
    return `${year}-${month}-${day}`;
}
const rules = reactive({
  status: [
    {
      required: true,
      message: "必填项",
      trigger: "change",
    },
  ],
  name: [
    {
      required: true,
      message: "必填项",
      trigger: "change",
    },
  ],
  certificateType: [
    {
      required: true,
      message: "必填项",
      trigger: "change",
    },
  ],
  idNumber:[
    {
        required: true,
        message: "必填项",
        trigger: "change",
    },
  ],
  phone:[
    {
        required: true,
        message: "必填项",
        trigger: "change",
    },
  ],
  isEmployees:[
    {
        required: true,
        message: "必填项",
        trigger: "change",
    },
  ],
  employeeType:[
    {
      required: true,
      message: "必填项",
      trigger: "change",
    },
  ],
  isSpecificIndustry:[
    {
        required: true,
        message: "必填项",
        trigger: "change",
    },
  ],
  isInvestors:[
    {
        required: true,
        message: "必填项",
        trigger: "change",
    },
  ],
  isAngelInvestors:[
    {
        required: true,
        message: "必填项",
        trigger: "change",
    },
  ],
  serviceDate:[
    {
        required: true,
        message: "必填项",
        trigger: "change",
    },
  ]
});
const emits = defineEmits(['confirm'])
const submitForm = (formEl) => {
  if (!formEl) return
  formEl.validate((valid) => {
    if (valid) {
      console.log(answer)
        const idNumbers = answer.value.map(item =>{
          return item.idNumber
        })
        if(idNumbers.includes(form.value.idNumber)){
          let obj = answer.value.find(item => item.idNumber == form.value.idNumber)
          const params = cloneDeep({...toRaw(form.value),name: obj.name})
          dialogVisible.value = false;
          emits('confirm',params)
        }else{
          return ElMessage({
            type:'warning',
            message:"请填写初始数据存在的身份证"
          })
        }
    } else {
      console.log('error submit!')
    }
  })
}

function changeEmployeeType(val) {
  rules.serviceDate[0].required = val != '其他'
  if (val == '其他') {
    form.value.serviceDate = null
    form.value.leaveDate = null
    form.value.isEmployees = '否'
  } else {
    form.value.isEmployees = '是'
  }
}
</script>

<template>
  <div>
    <el-dialog
        v-model="dialogVisible"
        draggable
        :modal="false"
        destroy-on-close
        modal-class="tax-add-user-8911"
        :close-on-click-modal="false"
        title="添加"
        width="670"
        @open="open">
      <div class="form-content">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleFormRef"
          label-width="auto"
        >
          <el-form-item label="人员状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio-button label="正常" value="正常" />
              <el-radio-button label="非正常" value="非正常" />
            </el-radio-group>
          </el-form-item>
          <p class="part">基本信息</p>
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入" />
              </el-form-item>
              <el-form-item label="证件类型" prop="certificateType">
                <el-select v-model="form.certificateType" placeholder="请选择">
                  <el-option label="居民身份证" value="居民身份证" />
                  <el-option label="中国护照" value="中国护照" />
                </el-select>
              </el-form-item>
              <el-form-item label="性别" prop="sex">
                <el-select v-model="form.sex" placeholder="请选择">
                  <el-option label="男" value="男" />
                  <el-option label="女" value="女" />
                </el-select>
              </el-form-item>
              <el-form-item label="职业" prop="occuptation">
                <el-input v-model="form.occuptation" placeholder="请输入" />
              </el-form-item>
              <el-form-item label="纳税人识别号" prop="taxpayerRegistrationNumber">
                <el-input v-model="form.taxpayerRegistrationNumber" placeholder="请输入" />
              </el-form-item>
              <el-form-item label="残疾证号" prop="disabilityCertificateNumber">
                    <el-input v-model="form.disabilityCertificateNumber" placeholder="请输入" />
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="国籍(地区)" prop="nationality">
                    <el-input v-model="form.nationality" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="证件号码" prop="idNumber">
                    <el-input @change="getBirthDateFromIdCard" v-model="form.idNumber" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="出生年月日" prop="year">
                    <el-input v-model="form.year" disabled placeholder="请输入" />
                </el-form-item>
                <el-form-item label="学历" prop="degree">
                    <el-select v-model="form.degree" placeholder="请选择">
                        <el-option label="研究生" value="研究生" />
                        <el-option label="大学本科" value="大学本科" />
                        <el-option label="大学本科以下" value="大学本科以下" />
                    </el-select>
                </el-form-item>
                <el-form-item label="是否存在一下情形" prop="situations">
                    <el-checkbox-group v-model="form.situations">
                        <el-checkbox label="残疾" value="残疾" />
                        <el-checkbox label="烈属" value="烈属" />
                        <el-checkbox label="孤老" value="孤老" />
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="烈属证号" prop="martyrsNumbers">
                    <el-input v-model="form.martyrsNumbers" placeholder="请输入" />
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="form.remark"  placeholder="请输入" />
                </el-form-item>
            </el-col>
          </el-row>
          <p class="part">联系方式</p>
          <el-row>
            <el-col :span="24">
                <el-form-item label="经常居住地" prop="habitualResidence">
                    <el-input v-model="form.habitualResidence" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="户籍地址" prop="permanentAddress">
                    <el-input v-model="form.permanentAddress" placeholder="请输入" />
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="手机号码" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="开户行" prop="openingBank">
                    <el-input v-model="form.openingBank" placeholder="请输入" />
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="email" prop="email">
                    <el-input v-model="form.email" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="银行账号" prop="bankAccount">
                    <el-input v-model="form.bankAccount" placeholder="请输入" />
                </el-form-item>
            </el-col>
          </el-row>
          <p class="part">任职受雇信息</p>
          <el-row>
            <el-col :span="24">
              <el-form-item label="任职受雇从业类型" prop="employeeType">
                <el-select
                    v-model="form.employeeType" placeholder="请选择"
                    @change="changeEmployeeType"
                >
                  <el-option label="雇员" value="雇员" />
                  <el-option label="保险营销员" value="保险营销员" />
                  <el-option label="证券经纪人" value="证券经纪人" />
                  <el-option label="实习学生（全日制学历教育）" value="实习学生（全日制学历教育）" />
                  <el-option label="其他" value="其他" />
                </el-select>
              </el-form-item>
            </el-col>

                <el-col :span="12">
                    <el-form-item label="任职受雇日期" prop="serviceDate">
                        <!-- <el-input v-model="form.serviceDate" placeholder="请输入" /> -->
                        <el-date-picker
                          v-model="form.serviceDate"
                          type="date"
                          value-format="YYYY-MM-DD"
                          placeholder="请选择"
                          :disabled="form.employeeType == '其他'"
                        />
                    </el-form-item>
                    <el-form-item label="是否雇员" prop="isEmployees">
                        <el-select v-model="form.isEmployees"
                                   :disabled="form.employeeType == '其他'"
                                   placeholder="请选择">
                            <el-option label="是" value="是" />
                            <el-option label="否" value="否" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否股东,投资者" prop="isInvestors">
                        <el-select v-model="form.isInvestors" placeholder="请选择">
                            <el-option label="是" value="是" />
                            <el-option label="否" value="否" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="公司股本总额" prop="totalEquity">
                        <el-input v-model="form.totalEquity" placeholder="请输入" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="离职日期" prop="leaveDate">
                        <el-input v-model="form.leaveDate"
                                  :disabled="form.employeeType == '其他'"
                                  placeholder="请输入" />
                    </el-form-item>
                    <el-form-item label="是否特定行业" prop="isSpecificIndustry">
                        <el-select v-model="form.isSpecificIndustry" placeholder="请选择">
                            <el-option label="是" value="是" />
                            <el-option label="否" value="否" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否天使投资者" prop="isAngelInvestors">
                        <el-select v-model="form.isAngelInvestors" placeholder="请选择">
                            <el-option label="是" value="是" />
                            <el-option label="否" value="否" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="个人投资总额" prop="totalIndividual">
                        <el-input v-model="form.totalIndividual" placeholder="请输入" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="工号" prop="employeesNo">
                        <el-input v-model="form.employeesNo" placeholder="请输入" />
                    </el-form-item>
                </el-col>
          </el-row>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm(ruleFormRef)">
            确认
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.form-content{
    height: 700px;
    overflow: auto;
    padding: 20px 5px 20px 0;
    box-sizing: border-box;
    .part {
      padding: 16px 0;
      font-size: 16px;
    }
}
</style>

<style lang="scss">
.tax-add-user-8911 {
  pointer-events: none;

  .el-dialog {
    pointer-events: auto;
  }
}
</style>
